'use client'

import { useEffect } from 'react'
import Pusher from 'pusher-js'
import { emitEvent } from '@ginieapp/ginie-ui';

export default function PusherConnector(props) {
  
  let pusher = null;

  useEffect(() => {

    if (pusher == null) {
      pusher = new Pusher(props.pusherKey || process.env.NEXT_PUBLIC_PUSHER_KEY, {
        cluster: 'us2',
        encrypted: true
      })
    }
    
    pusher.connection.bind( 'error', function( err ) {
      if (process.env.NODE_ENV == 'development') console.error("---- PUSHER ERROR")
      if (process.env.NODE_ENV == 'development') console.error(err)
      if( err.data?.code === 4004 ) {
        log('Over limit!');
      }
    });

    if (props.channelId) subscribe(props.channelId)

    if (props.channelIds && Array.isArray(props.channelIds)) {
      props.channelIds.forEach(channelId => {
        subscribe(channelId)
      })
    }

    // return () => {
    //   if (pusher && process.env.NODE_ENV == 'development') console.log("PUSHER ---> DISCONNECT")
    //   if (pusher) pusher.disconnect();
    // }
    
  }, [])

  const subscribe = (channelId) => {
    const channel = pusher.subscribe(channelId);
    if (process.env.NODE_ENV == 'development') console.log("PUSHER: Subscribed to " + channelId)
    channel.bind_global((event, data) => {
      if (event.indexOf('pusher:') != 0) {
        data["__channel_id"] = channelId
        if (process.env.NODE_ENV == 'development') console.log("PUSHER MESSAGE: ", data)
        emitEvent(event, data)
      }
    });
  }

  return <></>
  
}